'use client'

import { useContext, useMemo } from "react"
import { LiveStreamContext } from "../_config"
import { tabWhiteList } from "@/type/sports"
import { DeviceContext } from "@/context/deviceContext"

export default function LiveSportsFilterTabs({ sportsFilter, setSportsFilter }: {
    sportsFilter: string
    setSportsFilter: Function
}) {
    function reorderSports(arr: string[]): string[] {
        const priorityMap = new Map(sportsOrder.map((key, index) => [key, index]));
        return [...arr].sort((a, b) => {
            const aOrder = priorityMap.get(a) ?? Infinity;
            const bOrder = priorityMap.get(b) ?? Infinity;
            return aOrder - bOrder;
        });
    }

    const { mobileMode } = useContext(DeviceContext)
    const { sportsFilterTab } = useContext(LiveStreamContext)
    const sportsOrder = [
        "",          // 전체
        "soccer",    // 축구
        "baseball",  // 야구
        "basket",    // 농구
        "hockey",    // 하키
        "football",  // 미식축구
        "volley",    // 배구
        "egame",     // 이스포츠
        "ETC"        // 기타
    ];

    const tab_list: string[] = useMemo(()=> {
        const reordered: string[] = [
            ...sportsFilterTab.filter(sport => sport !== 'ETC'),
            'ETC'
        ];

        return reorderSports(reordered).filter(el => tabWhiteList.includes(el));
    }, [sportsFilterTab])
    // console.log("***", reorderSports(reordered))
    return (
        <div className="live-sports-filter-tabs">
            <div className={`filter-tabs-list ${mobileMode && tab_list.length > 4 ? "flex between" : ""}`}>
                {
                    tab_list.map((tab, index) => (
                        <button key={index}
                            className={sportsFilter == tab ? "active" : ""}
                            title={tab}
                            onClick={e => setSportsFilter(tab)}>
                            <i className={`--point sports-${tab || 0}`}></i>
                        </button>
                    ))
                }
            </div>
        </div>
    )
}